import React from "react";

const LightbulbIcon = ({ color = "#424242", ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path
      fill={color}
      fillRule="evenodd"
      d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.135 2 5 5.135 5 9a6.99 6.99 0 0 0 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26A6.99 6.99 0 0 0 19 9c0-3.865-3.135-7-7-7zm2.855 11.1l-.855.595V16h-4v-2.3l-.855-.595A5.005 5.005 0 0 1 7 9.005c0-2.755 2.245-5 5-5s5 2.245 5 5c0 1.625-.8 3.155-2.145 4.095z"
    />
  </svg>
);

export default LightbulbIcon;
